export default [
    {
        back: 'product_id',
        front: 'productID'
    },
    {
        back: 'sl_wholesale_discounts',
        front: 'wholesaleDiscounts'
    }
]